export interface BookTheme {
  primary: string;
  primaryDark: string;
  primaryLight: string;
  softBg: string;
  softBorder: string;
}

const THEME_MAP: Record<number, BookTheme> = {
  1: {
    primary: '#22c55e',
    primaryDark: '#15803d',
    primaryLight: '#dcfce7',
    softBg: '#f0fdf4',
    softBorder: '#bbf7d0',
  },
  2: {
    primary: '#3b82f6',
    primaryDark: '#1d4ed8',
    primaryLight: '#dbeafe',
    softBg: '#eff6ff',
    softBorder: '#bfdbfe',
  },
  3: {
    primary: '#ef4444',
    primaryDark: '#dc2626',
    primaryLight: '#fee2e2',
    softBg: '#fef2f2',
    softBorder: '#fecaca',
  },
  4: {
    primary: '#f97316',
    primaryDark: '#ea580c',
    primaryLight: '#ffedd5',
    softBg: '#fff7ed',
    softBorder: '#fed7aa',
  },
  5: {
    primary: '#ec4899',
    primaryDark: '#db2777',
    primaryLight: '#fce7f3',
    softBg: '#fdf2f8',
    softBorder: '#f9a8d4',
  },
  6: {
    primary: '#8b5e3c',
    primaryDark: '#6b4423',
    primaryLight: '#f2e7dc',
    softBg: '#faf4ee',
    softBorder: '#dfc6b1',
  },
  7: {
    primary: '#1e3a8a',
    primaryDark: '#172554',
    primaryLight: '#dbeafe',
    softBg: '#eff6ff',
    softBorder: '#bfdbfe',
  },
  8: {
    primary: '#eab308',
    primaryDark: '#ca8a04',
    primaryLight: '#fef9c3',
    softBg: '#fefce8',
    softBorder: '#fde68a',
  },
  9: {
    primary: '#14b8a6',
    primaryDark: '#0f766e',
    primaryLight: '#ccfbf1',
    softBg: '#f0fdfa',
    softBorder: '#99f6e4',
  },
};

export const DEFAULT_BOOK_THEME: BookTheme = {
  primary: '#7063ff',
  primaryDark: '#5a4fcf',
  primaryLight: '#e7e4ff',
  softBg: '#f5f3ff',
  softBorder: '#d9d5ff',
};

export function getBookTheme(bookId?: number | string | null): BookTheme {
  const numericBookId = Number(bookId);

  if (!Number.isFinite(numericBookId)) {
    return DEFAULT_BOOK_THEME;
  }

  const lastDigit = Math.abs(numericBookId) % 10;
  return THEME_MAP[lastDigit] ?? DEFAULT_BOOK_THEME;
}
